import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import SalesClosing from "./SalesClosing";
import ReportPic from "./ReportPic";

export default function ReportSales({ cfg, focus }) {
    const { user } = useAuth();
    const tabs = [...(cfg.can_sales_closing ? [["closing", "Sales Closing"]] : []), ["pic", "Report PIC"]];
    const [tab, setTab] = useState(focus?.tab || tabs[0][0]);
    return (
        <div className="space-y-4">
            <div className="inline-flex bg-white border border-mist rounded-sm p-0.5" data-testid="sales-tabs">
                {tabs.map(([k, l]) => (
                    <button key={k} type="button" onClick={() => setTab(k)} data-testid={`sales-tab-${k}`}
                        className={`px-4 py-2 text-xs uppercase tracking-widest rounded-sm ${tab === k ? "bg-ink text-white" : "text-neutral-500"}`}>{l}</button>
                ))}
            </div>
            {tab === "closing" && <SalesClosing cfg={cfg} date={focus?.tab === "closing" ? focus.date : undefined} />}
            {tab === "pic" && <ReportPic cfg={cfg} user={user} focus={focus?.tab === "pic" ? focus : null} />}
        </div>
    );
}
